import { Controller, FieldError, get, useFormContext } from 'react-hook-form';

import {
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Switch,
  SwitchProps,
  styled,
} from '@mui/material';

import { FormElementProps } from '@/components';

export interface FormSwitchFieldProps
  extends Omit<SwitchProps, 'name' | 'onChange'>,
    FormElementProps {
  label?: string;
  half?: boolean;
  handleChange?: (name: string, value: boolean) => void;
}
const Root = styled('div')(() => ({
  flex: 1,
  minWidth: '100%',
  maxWidth: '100%',
  marginBottom: 8,
  '& .MuiInputBase-root': {
    width: '100%',
  },
  '& .MuiFormControlLabel-label': {
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    marginTop: '1.5px',
  },
  '&.half': {
    minWidth: 'calc(50% - 10px)',
    maxWidth: 'calc(50% - 10px)',
  },
}));
export const FormSwitchField = (props: FormSwitchFieldProps) => {
  const { label, name, rules, half, handleChange } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name) as FieldError;
  return (
    <Root className={half ?? false ? 'half' : ''}>
      <InputLabel sx={{ visibility: 'hidden' }}>&nbsp;</InputLabel>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Switch
                className="checkbox"
                color="primary"
                {...field}
                checked={!!field.value}
                onChange={(e) => {
                  field.onChange(e);
                  if (handleChange) {
                    handleChange(name, e.target.checked);
                  }
                }}
              />
            }
            label={label}
          />
        )}
      />
      <FormHelperText error>{error?.message}</FormHelperText>
    </Root>
  );
};
